import { useParams } from 'react-router-dom';

import { useGetCommonAreasByIdQuery } from '@client/api';

import { CommonAreaInformationCard } from '../components/common-area-information-card.component';
import { SpaceAreaHistoryCard } from '../components/space-area-history/space-area-history-card.component';

export const CommonAreaView = () => {
  const { spaceId } = useParams<{ spaceId: string }>();

  const { data: space, isFetching } = useGetCommonAreasByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <CommonAreaInformationCard space={space} isFetching={isFetching} />

        <SpaceAreaHistoryCard spaceId={spaceId} />
      </div>
    </div>
  );
};
